import { getBusinessTodoCounts } from '@/api/businessTodo'

const PATH_COUNT_KEYS = {
  '/pricing/online-pricing': 'pricingOnline',
  '/pricing/direct-inquiry': 'pricingDirect',
  '/pricing/quote-review': 'pricingQuoteReview',
  '/kefu/shlbindex': 'customerServiceAudit',
  '/kefu/quote-review': 'customerServiceQuoteReview',
  '/kefu/pricing-return': 'customerServicePricingReturn'
}

const useBusinessTodoStore = defineStore('businessTodo', {
  state: () => ({
    counts: {},
    loading: false,
    loaded: false,
    lastLoadedAt: 0,
    requestPromise: null
  }),
  actions: {
    countForPath(path) {
      const normalizedPath = String(path || '').replace(/\/+$/, '') || '/'
      const key = PATH_COUNT_KEYS[normalizedPath]
      return key ? Number(this.counts[key] || 0) : 0
    },
    refresh(force = false) {
      if (this.requestPromise) {
        return this.requestPromise
      }
      if (!force && this.loaded && Date.now() - this.lastLoadedAt < 3000) {
        return Promise.resolve(this.counts)
      }
      this.loading = true
      this.requestPromise = getBusinessTodoCounts()
        .then(response => {
          this.counts = response.data || {}
          this.loaded = true
          this.lastLoadedAt = Date.now()
          return this.counts
        })
        .catch(() => this.counts)
        .finally(() => {
          this.loading = false
          this.requestPromise = null
        })
      return this.requestPromise
    }
  }
})

export default useBusinessTodoStore
